import { render, staticRenderFns } from "./CanCopy.vue?vue&type=template&id=7f42dd70&scoped=true"
import script from "./CanCopy.vue?vue&type=script&lang=js"
export * from "./CanCopy.vue?vue&type=script&lang=js"
import style0 from "./CanCopy.vue?vue&type=style&index=0&id=7f42dd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42dd70",
  null
  
)

export default component.exports